import {
  CommunicationView,
  useCommunicationHeader,
} from "@/components/communications/CommunicationView.tsx";
import { SidebarContent } from "@/components/ui/sidebar.tsx";
import { RightSidebarHeader } from "./elements.tsx";
import { useRightSidebar } from "./hooks.tsx";
import type { CommunicationSidebarSchema } from "./sidebarSchema.ts";

/** Read-only email / text-message detail in the right sidebar. */
export const CommunicationSidebar = ({ id }: CommunicationSidebarSchema) => {
  const { closeSidebar } = useRightSidebar();
  const { title } = useCommunicationHeader(id);

  return (
    <>
      <RightSidebarHeader title={title} handleClose={closeSidebar} />
      {/* Match the contact sidebar: an inset white card on the muted sidebar bg. */}
      <SidebarContent className="@container px-4 py-4">
        <CommunicationView id={id} density="compact" />
      </SidebarContent>
    </>
  );
};
